import { render, staticRenderFns } from "./RouteComponent.vue?vue&type=template&id=79423887&scoped=true&"
import script from "./RouteComponent.vue?vue&type=script&lang=js&"
export * from "./RouteComponent.vue?vue&type=script&lang=js&"
import style0 from "./RouteComponent.vue?vue&type=style&index=0&id=79423887&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79423887",
  null
  
)

export default component.exports